var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":("/jala_harvests/" + (_vm.item.jala_harvest_id))}},[_vm._v(_vm._s(_vm.harvest.cycle.pond.farm.name)+" - "+_vm._s(_vm.harvest.cycle.pond.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }